
import { EXPENSE_TYPES } from '@/modules/transactions/_constants/constants'
export const _sortOfficeConfiguration = (officeConfigData) => {
  if (officeConfigData.length > 0) {
    officeConfigData.forEach(el => {
      if (el.form === EXPENSE_TYPES.TRANSACTION) {
        el.order = 1
      }
      if (el.form === EXPENSE_TYPES.EXPENSE) {
        el.order = 2
      }
      if (el.form === EXPENSE_TYPES.REIMBURSEMENT) {
        el.order = 3
      }
      if (el.form === EXPENSE_TYPES.DIET) {
        el.order = 4
      }
      if (el.form === EXPENSE_TYPES.MILEAGE) {
        el.order = 5
      }
    })
  }
  return officeConfigData.sort((a, b) => a.order - b.order)
}

export const _generateOfficeConfiguration = (officeConfigData) => {
  let configurations = {}
  officeConfigData.forEach(item => {
    if (item.form === 'TRANSACTION_BILL') {
      configurations.TRANSACTION = configurations.TRANSACTION || {}
      configurations.TRANSACTION.BILL = item
    } else if (item.form === 'EXPENSE_BILL') {
      configurations.EXPENSE = configurations.EXPENSE || {}
      configurations.EXPENSE.BILL = item
    } else if (item.form === 'TRANSACTION') {
      configurations.TRANSACTION = configurations.TRANSACTION || {}
      configurations.TRANSACTION.RECEIPT = item
    } else if (item.form === 'EXPENSE') {
      configurations.EXPENSE = configurations.EXPENSE || {}
      configurations.EXPENSE.RECEIPT = item
    } else {
      configurations[`${item.form}`] = item
    }
  })
  return configurations
}
